// src/features/equipment/components/EquipmentStatusChip.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Build as BuildIcon,
  ReportProblem as ReportProblemIcon,
  Block as BlockIcon,
} from '@mui/icons-material';

export const EQUIPMENT_STATUSES = ['operational', 'in_maintenance', 'out_of_service', 'retired'];

// 'fault_reported' isn't stored; it's shown for operational equipment with an open fault report
const STATUS_CONFIG = {
  operational: { color: 'success', icon: CheckCircleIcon },
  fault_reported: { color: 'warning', icon: ReportProblemIcon },
  in_maintenance: { color: 'info', icon: BuildIcon },
  out_of_service: { color: 'error', icon: ReportProblemIcon },
  retired: { color: 'default', icon: BlockIcon },
};

export default function EquipmentStatusChip({ status, size = 'small', ...props }) {
  const { t } = useTranslation(['equipment']);
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.operational;
  const Icon = config.icon;

  return (
    <Chip
      icon={<Icon />}
      label={t(`equipment:status.${status || 'operational'}`)}
      size={size}
      color={config.color}
      variant="outlined"
      {...props}
    />
  );
}
